import ButtonApplePay from './ButtonApplePay'

export default ButtonApplePay
